import React from 'react';
import './Header.css';

const headerSetGoals = ({
    data,
    AllState,
    changeData,
    saveAreaGoalsIfNeeded,
    onAreaSaveFailed,
    pick7Browse = false,
    activeCategoryIndex = 0,
    onSelectCategory,
}) => (
    <div className="setGoalsNav__container">
        {data.map((item, index) => {
            const activeIndex = pick7Browse
                ? activeCategoryIndex
                : AllState.CurrentF;
            const isCurrent = activeIndex === index;
            const isCompleted = !pick7Browse && index < AllState.CurrentF;
            const isPending =
                !pick7Browse &&
                AllState.CurrentF < index &&
                AllState.LastReachedF < index;
            const isFullColor = pick7Browse
                ? isCurrent
                : isCurrent || isCompleted;
            const isPick7Active = pick7Browse && isCurrent;
            const isPick7Inactive = pick7Browse && !isCurrent;

            return (
                <button
                    key={item.name}
                    className={`subtitle-1 setGoalsNav__tab ${
                        isCurrent ? 'selected__zoom' : ''
                    }${!pick7Browse && !isFullColor ? ' tab__deactivated' : ''}${
                        isPick7Active ? ' tab__pick7-active' : ''
                    }${isPick7Inactive ? ' tab__pick7-inactive' : ''}${
                        isPending ? ' tab__pending' : ''
                    }`}
                    aria-current={isPick7Active ? 'true' : undefined}
                    onClick={() => {
                        if (pick7Browse) {
                            if (typeof onSelectCategory === 'function') {
                                onSelectCategory(index);
                            }
                            return;
                        }
                        if (index > AllState.LastReachedF) {
                            return;
                        }
                        const fromF = AllState.CurrentF;
                        changeData({
                            ...AllState,
                            CurrentF: index,
                        });
                        if (index <= fromF) {
                            return;
                        }
                        saveAreaGoalsIfNeeded(fromF, index).then(
                            (ok) => {
                                if (!ok && onAreaSaveFailed) {
                                    onAreaSaveFailed();
                                }
                            }
                        );
                    }}
                    type="button"
                    style={{
                        '--tab-category-color': item.tabColor,
                        backgroundColor:
                            pick7Browse && !isCurrent
                                ? undefined
                                : isFullColor
                                ? item.tabColor
                                : undefined,
                    }}
                >
                    <span>{item.name}</span>
                </button>
            );
        })}
    </div>
);

export default headerSetGoals;
